import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import './blCategoriesList.scss';
import BlCategory from './BlCategory';

const BlCategoriesList = ({addBlItem, selectedItems, selectedBusinessLunch, menuItemTypes}) => {
  const [blCategoryRelations, setBlCategoryRelations] = useState([]);

  useEffect(() => {
    if (!selectedBusinessLunch || !selectedBusinessLunch.category_relations || selectedBusinessLunch.category_relations.length === 0) {
      return;
    }
    setBlCategoryRelations(selectedBusinessLunch.category_relations);
  }, [selectedBusinessLunch]);

  const getCategoryItem = (category_id) => {
    if (!selectedBusinessLunch) {
      return null;
    }
    return selectedBusinessLunch.menuItems.find(mi => mi.menu_item_id === category_id);
  };

  return (
    <div className={ 'bl-categories-list' }>
      {
        blCategoryRelations.map(c => (
          <BlCategory blCategory={ getCategoryItem(c.menu_item_id) } addBlItem={ addBlItem } selectedItems={ selectedItems } selectedBusinessLunch={selectedBusinessLunch} menuItemTypes={menuItemTypes} />
        ))
      }
    </div>
  );
};

export default BlCategoriesList;
